var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 160C480 89.25 422.75 32 352 32C313.5 32 279.5 49.25 256 76.125C232.5 49.25 198.5 32 160 32C89.25 32 32 89.25 32 160C32 198.5 49.25 232.5 76.125 256C49.25 279.5 32 313.5 32 352C32 422.75 89.25 480 160 480C198.5 480 232.5 462.75 256 435.875C279.5 462.75 313.5 480 352 480C422.75 480 480 422.75 480 352C480 313.5 462.75 279.5 435.875 256C462.75 232.5 480 198.5 480 160ZM256 336C211.875 336 176 300.125 176 256S211.875 176 256 176S336 211.875 336 256S300.125 336 256 336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.36a4e4106a41f8c34f6e474a66bb7dbf.svg";
export { ForwardRef as ReactComponent };